import { CHANGEMEMBERMANAGER_SUCCESS, CHANGEMEMBERMANAGER_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const changeMemberManagerReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGEMEMBERMANAGER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case CHANGEMEMBERMANAGER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default changeMemberManagerReducer;
